import { pluralize } from '@belong/common';
import { IconAlert, IconArrowDown } from '@belong/icons';
import { Text, LinkBase } from '@belong/ui';
import { STRINGS } from 'action-items/strings';
import { clsx } from 'clsx';
import css from './action-item-count-link.module.css';

type Props = {
  count: number;
  propertyId?: string;
};

export function ActionItemCountLink({ count, propertyId }: Props) {
  if (count === 0) {
    return null;
  }

  return (
    <LinkBase
      href={`/accounts/portfolio/action-items/${propertyId}`}
      className={clsx('group flex items-center justify-between', css.link)}
    >
      <div className="flex items-center gap-xs uppercase text-red transition-colors duration-hover group-hover:text-dark-red">
        <IconAlert aria-hidden className={clsx('h-md w-md', css.alert)} />
        <Text fontWeight="semibold">{`${count} ${pluralize(count, STRINGS.actionItem)}`}</Text>
      </div>
      <IconArrowDown className={clsx('h-2sm', css.arrow)} />
    </LinkBase>
  );
}
